import { postForm } from '../utils/formUtil';

export interface UsrclkParam
  extends Record<string, string | number | boolean> {}

/**
 * 検索条件をセットしform送信を行う
 * @param {string} url
 * @param {Record<string, string | number>} formData
 * @param {UsrclkParam} usrclkParam
 */
export const postSearchConditions = (
  url: string,
  formData: Record<string, string | number>,
  usrclkParam: UsrclkParam
) => {
  postForm(url, formData, usrclkParam);
};
